import { graphql } from '@/gql';
import type { CopyRideToAnotherUserAndClearChargesMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const copyRideToAnotherUserAndClearCharges = async ({
  phoneNumber,
  requestId,
  notes,
}: CopyRideToAnotherUserAndClearChargesMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CopyRideToAnotherUserAndClearCharges($phoneNumber: String!, $requestId: String!, $notes: String!) {
        copyRideToAnotherUserAndClearCharges(phoneNumber: $phoneNumber, requestId: $requestId, notes: $notes) {
          id
        }
      }
    `),
    variables: {
      phoneNumber,
      requestId,
      notes,
    },
  });

  return !!response.data?.copyRideToAnotherUserAndClearCharges;
};
